export default __webpack_public_path__ + "static/media/notificatio.1dd512af.mp3";